import {Button} from '@primer/react-brand/esm'

import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'

import type {GenericCTAGroup} from '../../../../brand/lib/types/contentful'

type Props = {
  contentfulContent: GenericCTAGroup
  location: string
}

export function CtaButtons(props: Props) {
  const {contentfulContent, location} = props

  const {primary, secondary} = contentfulContent.fields

  return (
    /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
    <div className={`CtaForm${location !== 'hero' ? ' CTAForm-footer' : ''}`}>
      <Button
        /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
        className={`CtaForm-primaryAction ${location === 'hero' ? 'js-hero-action' : ''}`}
        as="a"
        href={primary.fields.href}
        variant="primary"
        {...getAnalyticsEvent({
          action: primary.fields.text,
          tag: 'button',
          context: 'CTAs',
          location,
        })}
      >
        {primary.fields.text}
      </Button>

      {secondary ? (
        <Button
          /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
          className={`CtaForm-secondaryAction ${location === 'hero' ? 'js-hero-action' : ''}`}
          as="a"
          href={secondary.fields.href}
          {...getAnalyticsEvent({
            action: secondary.fields.text,
            tag: 'button',
            context: 'CTAs',
            location,
          })}
        >
          {secondary.fields.text}
        </Button>
      ) : null}
    </div>
  )
}
